import React, { useEffect, useState } from 'react';
import AWS from 'aws-sdk';
import { ACCESS_KEYID, SECRET_ACCESS_KEY, BUCKET_NAME } from '../constants/config'
import { message } from "antd/lib/index";
import { API_PATH } from '../constants/ApiPath';
import axios from 'axios';

import ReactMarkdownWithHtml from 'react-markdown/with-html';



AWS.config.update({
  region: 'ap-south-1',
  accessKeyId: ACCESS_KEYID,
  secretAccessKey: SECRET_ACCESS_KEY
});
const s3 = new AWS.S3();

export function s3SignedUrl(key) {
  if (key !== undefined && key !== null && key !== "") {
    if (key === "" || key.includes("https")) {
      return key
    } else {
      try {
        const url = s3.getSignedUrl('getObject', {
          Bucket: BUCKET_NAME, // the name of your bucket
          Key: key, // name of object in S3
          Expires: 60 // how long the URL is good, in seconds
        });
        return url

      } catch (err) {
        // console.log(err, 'error');
        return key
      }
    }
  } else {
    return key
  }

};
export function s3SignedUrlWithoutExpires(key) {
  if (key !== undefined && key !== null) {
    if (key === "" || key.includes("https")) {
      return key
    } else {
      try {
        const url = s3.getSignedUrl('getObject', {
          Bucket: BUCKET_NAME, // the name of your bucket
          Key: key, // name of object in S3
          // Expires: 30 // how long the URL is good, in seconds
        });
        return url

      } catch (err) {
        // console.log(err, 'error');
        return key
      }
    }
  } else {
    return key
  }

};


export function s3download(key) {
  try {
    const params = { Bucket: BUCKET_NAME, Key: key, Expires: 300, ResponseContentDisposition: `attachment; filename="declaration_file.docx"` };
    const url = s3.getSignedUrl('getObject', params);
    return url
  } catch (err) {
    console.log(err, 'error');
    message.error('Failed to Download the file');
  }
}


// S3UploadAdapter.js

export function MyS3UploadAdapter(loader) {
  let abortController = new AbortController();
  const headers = {
    'Authorization': `Token ${localStorage.getItem('token') ? localStorage.getItem('token') : ''}`,
  }
  return {
    upload: async () => {
      const file = await loader.file;

      // 1. Get pre-signed S3 upload URL from Django backend
      const { data } = await axios.post(API_PATH.concat('/management/get-presigned-url-for-upload/'), {
        filename: file.name,
        filetype: file.type,
      }, { headers });

      if (!data?.s3_key || !data?.uploadUrl) {
        throw new Error('Invalid S3 response: missing upload URL or public URL');
      }

      // 2. Upload file to S3
      await axios.put(data.uploadUrl, file, {
        headers: {
          'Content-Type': file.type,
        },
        signal: abortController.signal,
        onUploadProgress: (e) => {
          if (loader.uploadTotal) {
            loader.uploaded = e.loaded;
            loader.uploadTotal = e.total;
          }
        },
      });

      // 3. Return public S3 URL to CKEditor
      return {
        default: s3SignedUrl(data.s3_key),
        key: data.s3_key // e.g., https://your-bucket.s3.amazonaws.com/image.jpg
      };
    },

    abort: () => {
      abortController.abort();
    },
  };
}
// src/ckeditor/S3UploadAdapterPlugin.js
export default function S3UploadAdapterPlugin(editor) {
  editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
    return new MyS3UploadAdapter(loader);
  };
}
export function getS3KeyFromSignedUrl(url) {
  try {
    const parsedUrl = new URL(url);
    return decodeURIComponent(parsedUrl.pathname.slice(1)); // Remove leading "/"
  } catch (err) {
    console.error("Invalid URL:", err);
    return null;
  }
}

export function MarkdownDisplay({ rawHtml }) {
  const [processedHtml, setProcessedHtml] = useState('');

  useEffect(() => {
    const replaceS3Urls = async () => {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = rawHtml;

      const imgs = tempDiv.querySelectorAll('img');
      for (let img of imgs) {
        const src = img.getAttribute('src');
        if (src) {
          const key = getS3KeyFromSignedUrl(src);
          const public_url = s3SignedUrl(key);
          img.setAttribute('src', public_url);
        }
      }

      setProcessedHtml(tempDiv.innerHTML);
    };

    replaceS3Urls();
  }, [rawHtml]);

  return <ReactMarkdownWithHtml allowDangerousHtml>{processedHtml}</ReactMarkdownWithHtml>;
}

export function processMarkdownWithSignedUrls(rawHtml) {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = rawHtml;

  const imgs = tempDiv.querySelectorAll('img');
  for (let img of imgs) {
    const src = img.getAttribute('src');
    if (src) {
      const key = getS3KeyFromSignedUrl(src);
      if (key) {
        const public_url = s3SignedUrl(key);
        img.setAttribute('src', public_url);
      }
    }
  }

  return tempDiv.innerHTML;
}

export async function uploadDirectToS3(file, presignedData) {
  const formData = new FormData();
  // Append fields from presigned data
  Object.keys(presignedData.fields).forEach((key) => {
    formData.append(key, presignedData.fields[key]);
  });

  // Explicitly set Content-Type if not already in fields
  if (!presignedData.fields['Content-Type']) {
    formData.append("Content-Type", file.type);
  }

  // Append file - MUST be the last field
  formData.append("file", file);

  try {
    await axios.post(presignedData.url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return true;
  } catch (error) {
    console.error("Error uploading to S3:", error);
    throw error;
  }
}
